module.exports = __webpack_public_path__ + "assets/img/mc3.ca66ce11.png";